// Module
var code = "<p>לאחר שהתחברתם לאתר, תוכלו ללחוץ על לחצן החשבון שבחלקו העליון של עמוד הבית ולבחור בניהול נכסים. לחצו על הלחצן &quot;פעיל&quot;, והופ! המודעה מיד תהפוך ללא פעילה.</p> ";
// Exports
export default code;